import { useEffect } from 'react';
import { useGoogleOAuth } from '@react-oauth/google';
import { ensureGoogleIdentityInitialized } from '../../utils/googleGsi';

/** Inicializa GIS una vez cuando el script y el Client ID están listos. */
export default function GoogleGsiInitializer() {
  const { clientId, scriptLoadedSuccessfully } = useGoogleOAuth();

  useEffect(() => {
    if (!scriptLoadedSuccessfully || !clientId) return;
    ensureGoogleIdentityInitialized(clientId);
  }, [scriptLoadedSuccessfully, clientId]);

  return null;
}
